<template>
  <div v-if="website.id" class="ba-w-100 ba-grid ba-gp-08">
    <form v-if="website" class="ba-w-100 ba-grid ba-gp-08">
      <div class="ba-w-100 ba-flex ba-gp-08">
        <div class="ba-grid ba-w-50 ba-gp-06">
          <div class="ba-flex ba-ai-center">
            <span for="keyword" class="ba-custom-label" v-text="$t('ct-key-word')"></span>
            <builderall-icon 
              style="width: 18px; height: 18px;"
              ba-tooltip-position='right' 
              :ba-tooltip-title="$t('ct-key-words-plch')"
              class="ba-color-light15"
              code='help'></builderall-icon>
          </div>
          <input type="text" id="keyword" class="ba-input ba-md" :placeholder="$t('ct-key-words-plch-seo')"
            v-model="website.layout.configuration.keyword" />
        </div>
        <div class="ba-grid ba-w-50 ba-gp-06">
          <div class="ba-flex ba-ai-center">
            <span for="metatag" class="ba-custom-label" v-text="$t('ct-metatag')"></span>
            <builderall-icon 
              style="width: 18px; height: 18px;"
              ba-tooltip-position='right' 
              :ba-tooltip-title="$t('ct-metatag-seo')"
              class="ba-color-light15"
              code='help'></builderall-icon>
          </div>
          <input id="metatag" class="ba-input ba-md" :placeholder="$t('ct-metatag-plch')"
            v-model="website.layout.configuration.metatag" />
        </div>
        </div>
        <div class="ba-w-100 ba-flex ba-gp-08">
        <div class="ba-grid ba-w-50 ba-gp-06">
          <div class="ba-flex ba-ai-center">
            <span for="robots" class="ba-custom-label" v-text="$t('ct-robots')"></span>
            <builderall-icon 
              style="width: 18px; height: 18px;"
              ba-tooltip-position='right' 
              :ba-tooltip-title="$t('ct-robots-seo')"
              class="ba-color-light15"
              code='help'></builderall-icon>
          </div>
          <input id="robots" class="ba-input ba-md" :placeholder="$t('ct-robots-plch-seo')"
            v-model="website.layout.configuration.robots" />
        </div>
        <div class="ba-grid ba-w-50 ba-gp-06">
          <div class="ba-flex ba-ai-center">
            <span for="ads" class="ba-custom-label" v-text="$t('ct-ads')"></span>
            <builderall-icon 
              style="width: 18px; height: 18px;"
              ba-tooltip-position='right' 
              :ba-tooltip-title="$t('ct-ads-seo')"
              class="ba-color-light15"
              code='help'></builderall-icon>
          </div>
          <input id="ads" class="ba-input ba-md" :placeholder="$t('ct-ads-plch-seo')"
            v-model="website.layout.configuration.ads" />
        </div>
      </div>
      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
        <button type="button" class="ba-btn ba-md ba-blue" data-ba-i="seo-settings" @click.prevent="saveSettings(website)">
          {{ $t('ct-save') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';
import ToggleButtonComponent from '../../commons/ToggleButtonComponent';

import {
  get as getWebsite,
  editSeo
} from '../../../js/services/editor/website';
import Errors from '../../../js/base/Errors';

export default {
  name: 'WebsiteSEO',
  components: {
    AlertBoxComponent,
    ToggleButtonComponent
  },
  data() {
    return {
      errors: new Errors(),
      website: {
        title: ''
      }
    };
  },

  methods: {
    redirectSeoRoute() {
      this.$router.push({
        name: 'ScriptSettings',
        params: { id: this.website.encrypted_id }
      });
    },
    saveSettings(website) {
      this.$loading.show();

      if (!this.errors.any()) {
        editSeo(website)
          .then(data => {
            this.$snotify.success(this.$t('ct-success-true'));
          })
          .catch(response => {
            if (response.response && response.response.data) { this.errors.record({ website: response.response.data.errors }) }

            this.$snotify.success(this.$t('ct-success-false'));
            console.warn(response);
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$loading.hide();
      }
    }
  },

  async created() {
    this.$loading.show();

    getWebsite(this.$route.params.id)
      .then(website => {
        this.website = website.data;
        this.website.layout = this.website.layouts[0];

        if (this.website.layout.configuration === null) {
          this.website.layout.configuration = {
            favicon: '',
            keyword: '',
            metatag: '',
            facebook_pixel: '',
            google_analytics: '',
            google_tag_manager: ''
          };
        }
      })
      .finally(() => this.$loading.hide());
  }
};
</script>

<style lang="scss" scoped>
.labelspacing {
  padding-left: 30px;
  padding-right: 60px;
}

.left {
  left: 30px;
}

.cheetah-seo-settings {
  &__header {
    h1 {
      font-family: 'Muli', sans-serif;
      font-size: 25px;
      font-weight: bold;

      color: #0080FC;
    }
  }

  &__content {
    .form-group {
      label {
        font-family: 'Muli', sans-serif;
        font-size: 16px;
        color: #5A5959;
      }

      input {
        height: 46px;
        text-overflow: ellipsis;
      }

      textarea {
        resize: none;
      }

      input,
      textarea {
        font-family: 'Muli', sans-serif;
        font-size: 13px;

        color: #656565;
        background: #FAFBFC;
        border-color: #E0E0E0;

        transition: all 0.2s;

        &:focus {
          outline: none;
          border-color: #0080FC;
          box-shadow: none;
        }
      }
    }
  }

  &__illustration {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 480px;

    margin-left: 25px;

    img {
      width: 100%;
    }
  }

  .card {
    margin-top: 15px;

    &-header {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;

      color: #333333;
      background-color: #F7F7F7;

      box-shadow: 0px 6px 3px #7E7E7E10;
      padding: 24px 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/views/WebsiteSEO.vue